import React, { useState, useEffect } from "react";
import QuestionInfoHeader from "./QuestionInfoHeader";
import { Typography } from "@mui/material";
import ButtonSection from "./ButtonSection";

function QuestionSection({
  questionData = [],
  currentQuestion = 0,
  handleOptionChange,
  handleSaveNextDefault,
  handleMarkReviewDefault,
  handleClearResponse,
  selectedOptionId,
  handleBack,
  currentQuestionBySubject,
  handleOpenSubmitModal,
  setCurrentQuestionBySubject
}) {
  const [question, setQuestion] = useState(null);
  const [optionId, setOptionId] = useState(selectedOptionId); // ✅ store selected option ID

  const handleOptionSelect = (id) => {
    setOptionId(id);
    handleOptionChange({ target: { value: id } });
  };

  useEffect(() => {
    if (Array.isArray(questionData) && questionData.length > 0) {
      const currentQ = questionData[currentQuestion];
      setQuestion(currentQ);
      // setOptionId(null); // reset selection on question change
    }
  }, [currentQuestion, questionData]);
  useEffect(() => {
    if (selectedOptionId) {
      handleOptionSelect(selectedOptionId);
    }
  }, [selectedOptionId]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "80%",
        height: "calc(100vh - 100px)",
        borderRight: "1px solid black",
      }}
    >
      {question && (
        <div>
          <QuestionInfoHeader
            currentQuestion={currentQuestionBySubject}
            maximumMark={parseFloat(question?.mark ?? 0).toFixed(2)}
            negativeMark={parseFloat(question?.negative_mark ?? 0).toFixed(2)}
          />

          <div
            style={{
              padding: "20px",
              maxHeight: "calc(100vh - 220px)",
              overflow: "auto",
            }}
          >
            <Typography>
              <span
                dangerouslySetInnerHTML={{
                  __html: question.question_en,
                }}
              />
            </Typography>

            <div style={{ padding: "15px" }}>
              {question?.options?.map((option, index) => {
                const isSelected = optionId === option.id;

                return (
                  <Typography
                    key={option.id || index}
                    style={{
                      padding: "10px 0px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        marginRight: "8px",
                        padding: "2px 8px",
                        border: "1px solid black",
                        borderRadius: "100%",
                        backgroundColor: isSelected ? "#4caf50" : "transparent", // ✅ highlight if selected
                        color: isSelected ? "white" : "black",
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOptionSelect(option.id)}
                    >
                      {String.fromCharCode(65 + index)}
                    </span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: option.option_en,
                      }}
                    />
                  </Typography>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <ButtonSection
        currentQuestion={currentQuestion}
        handleSaveNextDefault={handleSaveNextDefault}
        handleMarkReviewDefault={handleMarkReviewDefault}
        handleClearResponse={handleClearResponse}
        setOptionId={setOptionId}
        handleBack={handleBack}
        isLast = {questionData.length === currentQuestion+1}
        handleOpenSubmitModal={handleOpenSubmitModal}
        setCurrentQuestionBySubject={setCurrentQuestionBySubject}
        currentQuestionBySubject={currentQuestionBySubject}
      />
    </div>
  );
}

export default QuestionSection;
